import { getPatients, getPendingInvitations } from "~/api/patients";
import type { SortDirection } from "~/api/types";
import type { ToggleOptions } from "~/components/Patients/TableFilters";
import { usePaginatedQuery } from "./usePaginatedQuery";

export const useGetPatients = (
  currentPage: number,
  orderBy: string | null,
  search: string,
  sortDirection: SortDirection | null,
  userType: ToggleOptions[number]["value"],
  pageSize: number,
) => {
  const {
    query: { data: patientsData, isLoading: isLoadingPatients },
    totalItems: totalPatients,
  } = usePaginatedQuery({
    enabled: userType === "active",
    queryFn: () =>
      getPatients({
        page: currentPage,
        per_page: pageSize,
        search,
        order_by: orderBy,
        sort_direction: sortDirection,
      }),
    queryKey: [
      "getPatients",
      {
        page: currentPage,
        pageSize,
        search,
        orderBy,
        sortDirection,
      },
    ],
  });

  const {
    query: { data: invitationsData, isLoading: isLoadingInvitations },
    totalItems: totalInvitations,
  } = usePaginatedQuery({
    enabled: userType === "pending",
    queryFn: () =>
      getPendingInvitations({
        page: currentPage,
        per_page: pageSize,
        search,
        order_by: orderBy,
        sort_direction: sortDirection,
      }),

    queryKey: [
      "getPatientInvitations",
      {
        page: currentPage,
        pageSize,
        search,
        orderBy,
        sortDirection,
      },
    ],
  });

  return {
    patientsData,
    isLoadingPatients,
    totalPatients,
    invitationsData,
    isLoadingInvitations,
    totalInvitations,
  };
};
